import styled from 'styled-components';
import Radio from '@mui/material/Radio';

const StyledRadio = styled(Radio)`
  &.MuiRadio-colorPrimary.Mui-checked {
    color: #1594db;
  }
`;

export { StyledRadio };
